import { render, staticRenderFns } from "./HC_helpList.vue?vue&type=template&id=01a3765f&"
import script from "./HC_helpList.vue?vue&type=script&lang=js&"
export * from "./HC_helpList.vue?vue&type=script&lang=js&"
import style0 from "./HC_helpList.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports